// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1myvG","productName":"Table_productName__lVWZB"};